import { TranslationUserRegisterMessages, UserRegisterMessages } from "../interfaces";

export const messages: TranslationUserRegisterMessages = {
  [UserRegisterMessages.titleCreate]: "Create user",
  [UserRegisterMessages.titleEdit]: "Edit user",
  [UserRegisterMessages.stepTabFormUser]: "User data",
  [UserRegisterMessages.stepTabAddUserToRoles]: "Add to groups",
  [UserRegisterMessages.stepTabModuleAccess]: "Module access",
  [UserRegisterMessages.roleNotSelected]: "It is not possible to continue, as no group was selected",
  [UserRegisterMessages.roleNotFound]: "The selected group was not found",
  [UserRegisterMessages.noRolesRegistered]: "There are no registered groups",
  [UserRegisterMessages.confirmUserEditModalTitle]: "Change confirmation",
  [UserRegisterMessages.confirmUserEditModalDescription]: "You are saving a user without a group."
    + " If he has custom permissions, they will be lost. Are you sure you want to continue?",
  [UserRegisterMessages.confirmUserInactivateModalTitle]: "Inactivate confirmation",
  [UserRegisterMessages.confirmUserInactivateModalDescription]: "By confirming, the user will be inactivate from all Topcon solutions. "
      + "Are you sure you want to continue?",
  [UserRegisterMessages.moduleAccessTitle]: "Module access",
  [UserRegisterMessages.moduleAccessCaption]: "Controls which products the user can enter. Groups and permissions live inside each product"
    + " and require module access to be granted first.",
  [UserRegisterMessages.moduleAccessNoModules]: "No modules available for this tenant.",
  [UserRegisterMessages.moduleAccessSaveSuccess]: "Module access updated.",
  [UserRegisterMessages.moduleAccessSaveError]: "Failed to save module access.",
  [UserRegisterMessages.moduleAccessNoChanges]: "No pending changes.",
  [UserRegisterMessages.moduleAccessAdminNotice]: "This user is an administrator and automatically has access to every module"
    + " the tenant has contracted. Access cannot be changed manually."
};